import React, { Component } from "react";
import Select from "react-select";
import {
  formatoSeparadorMilesReturn,
  formatoSeparadorMilesValue,
} from "../generico/utils/FormatoInput";

const tipoCuenta = {
  ahorro_vista: "AHORRO_VISTA",
  ahorro_programado: "AHORRO_PROGRAMADO",
  rueda_gigante: "RUEDA_GIGANTE",
};

export default class CuentaSocio extends Component {
  constructor(props) {
    super(props);
     
  }

  componentDidMount() {}

  obtenerTitulo() {
    return (
      <label className="input-label-bold">
        Seleccione la Cuenta Origen (a debitar) *
      </label>
    );
  }

  handleChangeSelector = (selectedOption) => {
    var item = this.props.items;
    if (selectedOption === null) {
      this.props.selectorValue({}, []);
    } else {
      for (var i = 0; i < item.length; i++) {
        if (selectedOption.value === item[i].cuenta) {         
          this.props.selectorValue(item[i], selectedOption);
          break;
        }
      }
    }
  };

  handleChangeMonto = (evt) => {
    var _monto = formatoSeparadorMilesReturn(evt);
    this.props.montoValue(_monto);
  };

  obtenerCuenta() {    
    switch (this.props.tipoCuenta) {
      case tipoCuenta.ahorro_vista:
        var item = this.props.items;
        var options = [];
        for (var i = 0; i < item.length; i++) {
          options.push({
            value: item[i].cuenta,
            label:
              item[i].cuenta +
              " - " +
              item[i].tipoDeCuenta +
              " Saldo: " +
              formatoSeparadorMilesValue(item[i].saldoActual) +
              " " +
              item[i].moneda +
              ".",
          });
        }

        return (
          <div>
            <Select
              required="required"
              placeholder="-- Seleccione --"
              value={this.props.itemSelected}
              onChange={this.handleChangeSelector}
              options={options}
              isClearable
              noOptionsMessage={() => "SIN DATOS"}
            />
          </div>
        );

      case tipoCuenta.ahorro_programado:
        return <div className="form-group"></div>;
      case tipoCuenta.rueda_gigante:
        return <div className="form-group"></div>;
    }
  }

  render() {
   // const { selectedOption } = this.state;
    return (
      <div>
        <div className="form-group">
          {this.obtenerTitulo()}
          {this.obtenerCuenta()}
        </div>
        {this.props.renderMonto === "true" && (
          <div className="form-group">
            <label className="input-label-bold">{this.props.titleImporte!==undefined?this.props.titleImporte:"Importe a Transferir *"}</label>
            <input
              value={this.props.monto}
              maxLength="19"
              required
              placeholder="Monto a Transferir"
              onChange={this.handleChangeMonto}
              className="form-control input-box"
            />
          </div>
        )}
      </div>
    );
  }
}
